import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            六大分类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${cat.color} transition-transform duration-300 group-hover:scale-110`}>
                <i className={`${cat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <span className="mt-3 md:mt-4 text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{cat.name}</span>
              <span className="mt-1 text-xs text-foreground-500">{cat.count} 篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}